export default __webpack_public_path__ + "static/media/StaticBottomBanner.2313f8a4.png";